// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"7a5102e9","713":"259d7a0f","759":"7a5102e9","780":"7a5102e9"}[chunkId] + ".chunk.css";
};